import { styled, alpha } from '@mui/material/styles';
import { FONT_MONO } from 'themes/tokens';

export const EdgeLabelChip = styled('div', {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error?: boolean }>(({ theme, error }) => ({
  position: 'absolute',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '3px 9px',
  borderRadius: 100,
  fontFamily: FONT_MONO,
  fontSize: 11,
  fontWeight: 700,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  color: error ? theme.palette.error.light : theme.palette.info.main,
  backgroundColor: alpha(theme.palette.background.paper, 0.85),
  border: `1px solid ${error ? alpha(theme.palette.error.main, 0.5) : theme.palette.divider}`,
  backdropFilter: 'blur(4px)',
  WebkitBackdropFilter: 'blur(4px)',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
}));

export const EdgeIndexBadge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'error',
})<{ error?: boolean }>(({ theme, error }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 16,
  height: 16,
  padding: '0 4px',
  borderRadius: 100,
  fontSize: 10,
  fontWeight: 700,
  color: error ? theme.palette.error.contrastText : theme.palette.primary.contrastText,
  backgroundColor: error ? theme.palette.error.main : theme.palette.primary.main,
}));
